let comparisonCategoriesArray = [];
class compareProduct extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute("section") || false;
    this.sectionDialog = document.getElementById(`comparison_popup_${this.sectionId}`);
    try {
      this.initialMarkup = `
        <div class="align-center rte">
          <p class="heading-extrasmall gradient-text"><strong>Add a Product to Compare</strong></p>
          <p class="nomargin-start">
            <button type="button"
              class="open-comparison-btn comparison-btn align-center">
              <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.5 0V27" stroke="#FAFAFA" stroke-width="3"/>
                <path d="M27 13.5H0" stroke="#FAFAFA" stroke-width="3"/>
              </svg>
            </button>
          </p>
        </div>`;
      this.innerHTML = this.initialMarkup;
    } catch (error) {
      this.innerHTML = "Failed to initialise. Please refresh the page.";
    }
  }

  /*
   * Open compare products dialog.
   */
  openComparisonPopup(event) {
    this.sectionDialog.showModal();
    const compareProductsSwiper = new Swiper(`#comparison_popup_${this.sectionId} .swiper`, {
      loop: false,
      centeredSlides: false,
      centeredSlidesBounds: true,
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: false,
      navigation: {
        nextEl: ".swiper-scroll-right",
        prevEl: ".swiper-scroll-left",
      },
      breakpoints: {
        800: {
          slidesPerView: 4,
          spaceBetween: 32,
        },
      },
    });
  }

  /*
   * Remove product from the comparison grid.
   */
  resetProduct(handle) {
    this.classList.remove("product-card", "card");
    this.innerHTML = this.initialMarkup;
    const btnOpen = this.querySelector(".open-comparison-btn");
    const card = this.sectionDialog.querySelector(`.product-card[data-handle="${handle}"]`);
    if (card) {
      card.classList.remove("added");
      const popupButton = card.querySelector(".add-to-comparison-btn");
      if (popupButton) {
        popupButton.disabled = false;
      }
      const primarySectionId = document.querySelector("compare-product")?.getAttribute("section");
      if (this.sectionId === primarySectionId) {
        document.querySelector(`.products-grid .product-card[data-handle="${handle}"]`)?.classList.remove("added");
      }
    }
    if (btnOpen) {
      btnOpen.addEventListener("click", this.openComparisonPopup.bind(this));
    }
    // Re-enable add buttons because a comparison slot is now available.
    document.querySelectorAll(`.add-to-comparison-btn[data-section="${this.sectionId}"]`).forEach((btn) => {
      btn.disabled = false;
    });
    // Remove the mobile grid headings.
    if (document.getElementById(this.sectionId).querySelectorAll("compare-product:not(.card)").length == 3) {
      if (document.getElementById(this.sectionId).querySelector(".compare-product-headings")) {
        document.getElementById(this.sectionId).querySelector(".compare-product-headings").innerHTML = "";
      }
    }
  }

  /*
   * Runs each time the element is appended to or moved into the DOM.
   */
  connectedCallback() {
    try {
      // Attach a click event listener to the "open modal" button.
      let btnOpen = this.querySelector(".open-comparison-btn");
      if (!btnOpen) {
        return;
      }
      btnOpen.addEventListener("click", this.openComparisonPopup.bind(this));
    } catch (error) {}
  }
}
// Define the new web component
if ("customElements" in window) {
  customElements.define("compare-product", compareProduct);
}

/*
 * Add product to comparison section.
 * @param el – The button element.
 * @var sectionId – ID of section so we know which one to update.
 * @var data – Escaped JSON product data, captured from data-json attribute set
 *            on the button (el).
 */
function addProductToComparison(el) {
  const sectionId = el.dataset.section;
  const primarySectionId = document.querySelector("compare-product")?.getAttribute("section");
  const shouldUpdateInjectedButtons = sectionId === primarySectionId;
  const dialog = document.getElementById(`comparison_popup_${sectionId}`);
  const productData = JSON.parse(el.dataset.json);
  const metafieldsData = JSON.parse(el.dataset.metafields);
  const categoriesData = JSON.parse(el.dataset.categories);
  const otherData = {
    subscription: {
      monthly_price: el.dataset.monthlyPrice,
      monthly_compareatprice: el.dataset.monthlyCompareatprice,
      annual_price: el.dataset.annualPrice,
      annual_compareatprice: el.dataset.annualCompareatprice,
    },
    image_src: el.dataset.imageSrc,
    section_id: sectionId,
    primary_section_id: primarySectionId,
  };
  const data = { ...productData, ...metafieldsData, ...categoriesData, ...otherData };
  const template = document.getElementById(sectionId).querySelector("div.product-card");
  // console.log({ sectionId, data, template });

  el.closest(".product-card").classList.add("added");
  if (shouldUpdateInjectedButtons) {
    document.querySelector(`.products-grid .product-card[data-handle="${el.dataset.handle}"]`)?.classList.add("added");
  }
  dialog.querySelector(`.product-card[data-handle="${el.dataset.handle}"]`).classList.add("added");

  // Insert product into comparison grid.
  let item = document.querySelector(`compare-product[section="${sectionId}"]:not(.product-card)`);
  if (!item) {
    console.warn("No available comparison slots.");
    return;
  }
  let updatedElement = _renderComparisonProduct(data, template);
  item.classList.add("product-card", "card");
  item.innerHTML = updatedElement;

  // Disable add buttons when no comparison slots remain.
  const emptySlots = document.querySelectorAll(`compare-product[section="${sectionId}"]:not(.product-card)`).length;
  if (emptySlots === 0) {
    document.querySelectorAll(`.add-to-comparison-btn[data-section="${sectionId}"]`).forEach((btn) => {
      btn.disabled = true;
    });
  }

  // Display the correct subscription price.
  let toggleEl = document.getElementById(`shopify-section-${sectionId}`).querySelector(".js--toggle-prices");
  toggleProductGridPrices(toggleEl);

  if (event.target.classList.contains("injected-compare-btn")) {
    document.getElementById(sectionId).scrollIntoView();
  }

  // Close the comparison popup.
  dialog.close();
}

/*
 * Event listener for removing a product from the comparison grid.
 */
document.addEventListener("click", (event) => {
  const btn = event.target.closest(".remove-comparison-product");
  if (!btn) {
    return;
  }
  const component = btn.closest("compare-product");
  component?.resetProduct(btn.dataset.handle);
});

/*
 * Render product html for the comparison grid.
 */
function _renderComparisonProduct(data, template) {
  // Mobile (automatic comparison grids only).
  const compareGrid = document.getElementById(data.section_id)?.querySelector(".compare-products-grid");
  const isManual = compareGrid?.dataset.manual === "true";
  const comparisonCategoryOrder = JSON.parse(compareGrid?.dataset.listOrder);
  // console.log(comparisonCategoryOrder);

  if (window.matchMedia("(max-width:1024px)").matches && !isManual) {
    // Full list of categories.
    data.comparison_categories.forEach((item) => {
      if (!comparisonCategoriesArray.includes(item)) {
        comparisonCategoriesArray.push(item);
      }
    });
    comparisonCategoriesArray.sort((a, b) => {
      const aIndex = comparisonCategoryOrder.indexOf(a);
      const bIndex = comparisonCategoryOrder.indexOf(b);
      return (aIndex === -1 ? Number.MAX_SAFE_INTEGER : aIndex) - (bIndex === -1 ? Number.MAX_SAFE_INTEGER : bIndex);
    });
    // console.log(comparisonCategoriesArray); // For @testing

    // If this is the first "space", we need to display the row titles before it.
    const section = document.getElementById(data.section_id);
    let cardCount = section.querySelectorAll(".card").length;
    let headingRows = ``;
    comparisonCategoriesArray.forEach((item) => {
      headingRows += `<li data-text="${item}">${item}</li>`;
    });
    let headings = `
      <div class="compare-card_heading">&nbsp;</div>
      <ul class="compare-card_list">
        ${headingRows}
      </ul>
      <div class="compare-card_price">
        <div data-monthly-cost="true">Monthly Cost</div>
        <div data-monthly-cost="false" class="hidden">Annual Cost</div>
      </div>
      `;
    section.querySelector(".compare-product-headings").innerHTML = headings;

    // Rebuild existing cards so they contain every category in the same order.
    section.querySelectorAll(".card [data-js='features-list']").forEach((list) => {
      const existingCategories = JSON.parse(list.dataset.categories || "[]");
      // console.log({ existingCategories, comparisonCategoriesArray }); // @testing
      let updatedList = "";
      comparisonCategoriesArray.forEach((category) => {
        if (existingCategories.includes(category)) {
          updatedList += `
            <li data-text="${category}">
              <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.07568 4.64565L6.32568 10.0457L15.0757 1.04565" stroke="#3FCF29" stroke-width="3"/>
              </svg>
            </li>`;
        } else {
          updatedList += `
            <li data-text="${category}">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.06055 12.0605L12.0605 1.06055" stroke="#D6264D" stroke-width="3"/>
                <path d="M12.0605 12.0605L1.06055 1.06055" stroke="#D6264D" stroke-width="3"/>
              </svg>
            </li>`;
        }
      });
      list.innerHTML = updatedList;
    });

    // Create the category list for this item.
    let categoryList = "";
    comparisonCategoriesArray.forEach((category) => {
      if (data.comparison_categories.includes(category)) {
        categoryList += `
        <li data-text="${category}">
          <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.07568 4.64565L6.32568 10.0457L15.0757 1.04565" stroke="#3FCF29" stroke-width="3"/>
          </svg>
        </li>`;
      } else {
        categoryList += `
          <li>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.06055 12.0605L12.0605 1.06055" stroke="#D6264D" stroke-width="3"/>
              <path d="M12.0605 12.0605L1.06055 1.06055" stroke="#D6264D" stroke-width="3"/>
            </svg>
          </li>`;
      }
    });

    // Add the card.
    const mobileTemplate = document.createElement("div");
    mobileTemplate.className = "product-card card";
    mobileTemplate.innerHTML = `
      <div class="compare-card_heading"><h3>${data.title}</h3></div>
      <ul class="compare-card_list"
        data-js="features-list"
        data-categories='${JSON.stringify(data.comparison_categories)}'>
        ${categoryList}
      </ul>
      <div class="compare-card_price">
        <div data-monthly-cost="true" class="align-center">
          <strong class="price-block-price gradient-text large-text">£${data.subscription.monthly_price}</strong>
        </div>
        <div data-monthly-cost="false" class="hidden align-center">
          <strong class="price-block-price gradient-text large-text">£${data.subscription.annual_price}</strong>
          ${data.subscription.annual_compareatprice > data.subscription.annual_price ? `<br><s>£${data.subscription.annual_compareatprice}</s>` : ``}
        </div>
      </div>
      <div class="button-group">
        <button type="button" class="remove-comparison-product align-center" data-handle="${data.handle}">
          <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.38462 6.875V20.625C1.38462 21.3813 2.00769 22 2.76923 22H15.2308C15.9923 22 16.6154 21.3813 16.6154 20.625V6.875H1.38462ZM5.53846 19.25H4.15385V9.625H5.53846V19.25ZM8.30769 19.25H6.92308V9.625H8.30769V19.25ZM11.0769 19.25H9.69231V9.625H11.0769V19.25ZM13.8462 19.25H12.4615V9.625H13.8462V19.25ZM16.9615 2.75H12.4615V1.03125C12.4604 0.75808 12.3507 0.496408 12.1562 0.303246C11.9617 0.110084 11.6982 0.00108618 11.4231 0L6.57692 0C6.30184 0.00108618 6.03834 0.110084 5.84383 0.303246C5.64932 0.496408 5.53956 0.75808 5.53846 1.03125V2.75H1.03846C0.763044 2.75 0.498908 2.85865 0.304158 3.05205C0.109409 3.24544 0 3.50775 0 3.78125V5.5H18V3.78125C18 3.50775 17.8906 3.24544 17.6958 3.05205C17.5011 2.85865 17.237 2.75 16.9615 2.75ZM11.0769 2.75H6.92308V1.39287H11.0769V2.75Z" fill="#393939"/>
          </svg>
        </button>
      </div>
      `;
    const clone = mobileTemplate.cloneNode(true);
    return clone.innerHTML;
  } else {
    // Desktop.
    if (!template) {
      const fallbackTemplate = document.createElement("div");
      fallbackTemplate.className = "product-card card";
      fallbackTemplate.innerHTML = `
        <div class="image-block"></div>
        <div class="heading-fixed-block"></div>
        <div class="richtext-block rte rte-with-lists"></div>
        <hr class="divider-block">
        <div class="price-block"></div>
        <hr class="divider-block">
        <div class="comparisons-block"></div>
        <hr class="divider-block">
        <div class="button-group"></div>
      `;
      template = fallbackTemplate;
    }
    const clone = template.cloneNode(true);

    // List of features
    let features = ``;
    data.comparison_categories.forEach((item) => {
      features += `<li class="metafield-single_line_text_field">${item}</li>`;
    });

    const mappings = {
      "image-block": `<img src="${data.image_src}" width="400" height="300" style="aspect-ratio: 4/3;object-fit: cover; object-position: center;">`,
      "heading-fixed-block": `<h3 class="heading-block">${data.title}</h3>`,
      "richtext-block": `<p>${data.product_summary}</p>`,
      "price-block": `
        <div>
          <div>
            <span class="price-block-label">Set-up Cost:</span>
            <strong class="price-block-price gradient-text">${Shopify.formatMoney(data.price)}</strong>
          </div>
          <div data-monthly-cost="true">
            <span class="price-block-label">Monthly Cost:</span>
            <strong class="price-block-price gradient-text">£${data.subscription.monthly_price}</strong>
          </div>
          <div data-monthly-cost="false" class="hidden">
            <span class="price-block-label">Annual Cost:</span>
            <strong class="price-block-price gradient-text">£${data.subscription.annual_price}</strong>
            ${data.subscription.annual_compareatprice > data.subscription.annual_price ? `<s>£${data.subscription.annual_compareatprice}</s>` : ``}
          </div>
        </div>`,
      "comparisons-block": `
        <ul class="metafields-single_line_text_field-array">
          ${features}
        </ul>`,
      "button-group": `
        <a class="button" href="/products/${data.handle}">View Alarm</a>
        <button type="button" class="button dark-outline remove-comparison-product" data-handle="${data.handle}">Remove</button>`,
    };

    Object.entries(mappings).forEach(([className, value]) => {
      clone.querySelectorAll(`.${className}`).forEach((el) => {
        el.innerHTML = value ?? "";
      });
    });
    return clone.innerHTML;
  }
}

function insertCompareButtons() {
  const popup = document.querySelector(".compare-products-popup");
  if (!popup) {
    return;
  }
  const items = popup.querySelectorAll(".product-card");
  items.forEach((item) => {
    let handle = item.dataset.handle;
    let theBtn = item.querySelector(".add-to-comparison-btn");
    let button = theBtn.cloneNode();
    button.classList.remove("icon", "pulse", "comparison-btn", "comparison-btn-small");
    button.classList.add("button", "stretch", "injected-compare-btn");
    button.innerHTML = "Compare";
    let grid = document.querySelector(".collection-products-section");
    if (grid) {
      let productGridCard = grid.querySelector(`.product-card[data-handle="${handle}"]`);
      if (productGridCard) {
        if (productGridCard.querySelector(".image-block")) {
          productGridCard.querySelector(".image-block").style.position = "relative";
          productGridCard.querySelector(".image-block").insertAdjacentHTML("afterbegin", button.outerHTML);
        }
      }
    }
  });
}
ready(() => {
  insertCompareButtons();
});
